export enum TipoAeroplanta  {
    Propias,
    Terceras
} 